<template>
    <span>
        {{ $tc('checkIn', i18nPosition, { date: getLastCheckInDateFromNow }) }}
    </span>
</template>

<script>
import { getFromNow as timeSinceNow } from '@/lib/date'

export default {
    name: 'LastCheckinDateFromNow',
    props: {
        lastCheckin: {
            type: Object,
        },
    },
    computed: {
        isCheckin() {
            return !!this.lastCheckin && !!this.lastCheckin.updated_at
        },
        i18nPosition() {
            return this.isCheckin ? 1 : 2
        },
        getLastCheckInDateFromNow() {
            if (this.isCheckin) return timeSinceNow(this.lastCheckin.updated_at)
        },
    },
    i18n: {
        messages: {
            'en-US': {
                checkIn: 'Last check-in {date} | There are no previous check-ins.',
            },
            'en-ES': {
                checkIn: 'Último check-in {date} | No hay check-ins previos.',
            },
            'pt-BR': {
                checkIn: 'Último check-in {date} | Nenhum check-in foi realizado.',
            },
        },
    },
}
</script>
